import { CATERING_PATH } from 'catering/constants/paths';

const isCateringRoute = () => {
  const pathname = window.location.pathname;
  return pathname.startsWith(CATERING_PATH);
};

export default isCateringRoute;
